import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { ConnectWallet } from "@bkry/bowline-components/ConnectWallet";
import { useWeb3React } from "@web3-react/core";
import { useSelector } from "react-redux";
import { SignInWithEthereumButton } from "@bkry/bowline-components/SignInWithEthereumButton";
import { getEnv } from "@bkry/bowline-utils";
import { useDispatch } from "react-redux";

const AuthorizeModal = (
  {
    children,
    title,
    visible,
    secondaryAction,
    primaryAction,
    modalReset,
    siweSuccessCallbackFnc,
  },
  context
) => {
  const dispatch = useDispatch();
  const { account } = useWeb3React();
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const suggestedChainOptions = useSelector(
    (state) => state.projects.defaultNetworks[REACT_APP_PROJECT_ID]
  );
  const signedInWithEthereum = useSelector(
    (state) => state.wallets.siweSuccess
  );
  return (
    <Modal
      isOpen={visible ? true : false}
      toggle={() => dispatch(modalReset())}
    >
      <ModalHeader>{title || context.t("Authorization required")}</ModalHeader>
      <ModalBody>
        {children}
        {!account && (
          <ConnectWallet
            buttonColor="primary"
            buttonSize="xl"
            buttonId="nav-connect-wallet"
            block
            suggestedChainId={suggestedChainOptions?.chain_id}
          />
        )}
        {account && !signedInWithEthereum && (
          <SignInWithEthereumButton
            color="primary"
            size="xl"
            block
            onSuccess={() => {
              siweSuccessCallbackFnc ? siweSuccessCallbackFnc() : false;
            }}
          />
        )}
      </ModalBody>
      {(primaryAction || secondaryAction) && (
        <ModalFooter>
          {secondaryAction && (
            <Button
              color="primary"
              outline
              onClick={() => dispatch(secondaryAction?.action())}
            >
              {secondaryAction?.title}
            </Button>
          )}
          {primaryAction && (
            <Button
              color="primary"
              onClick={() => dispatch(primaryAction?.action())}
            >
              {primaryAction?.title}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

AuthorizeModal.propTypes = {
  visible: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  siweSuccessCallbackFnc: PropTypes.func,
  children: PropTypes.any,
  modalReset: PropTypes.func,
  steps: PropTypes.any,
  title: PropTypes.string,
  primaryAction: PropTypes.any,
  secondaryAction: PropTypes.any,
};

AuthorizeModal.defaultProps = {};
AuthorizeModal.contextTypes = {
  t: PropTypes.func,
};

export default AuthorizeModal;
